import { render, staticRenderFns } from "./modalperformanceindicator.vue?vue&type=template&id=1a045aee"
import script from "./modalperformanceindicator.vue?vue&type=script&lang=js"
export * from "./modalperformanceindicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports